/* Skau Solutions – scroll-styret scene-motor (vanilla, ingen afhængigheder)
   Scroll-progress p (0..1) fra en sticky scene styrer en timeline. */
(function () {
  'use strict';
  var root = document.documentElement;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var scenes = document.querySelectorAll('[data-cine]');
  if (!scenes.length || reduce) return; // statisk fallback vises via CSS
  root.classList.add('cine-on');

  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  var lerp = function (a, b, t) { return a + (b - a) * t; };
  var ss = function (t) { t = clamp(t, 0, 1); return t * t * t * (t * (t * 6 - 15) + 10); }; // smootherstep
  var w = function (p, a, b) { return ss((p - a) / (b - a)); };
  var NS = 'http://www.w3.org/2000/svg';
  function el(tag, attrs, parent) {
    var n = document.createElementNS(NS, tag);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(n);
    return n;
  }
  var rad = function (d) { return d * Math.PI / 180; };

  /* ---------- Scene: økosystem (forside) ---------- */
  function ecosystem(host) {
    var stage = host.querySelector('.eco__stage');
    var svg = stage.querySelector('svg');
    var core = stage.querySelector('.eco__core');
    var areas = [].slice.call(stage.querySelectorAll('[data-area]'));
    var prods = [].slice.call(stage.querySelectorAll('[data-prod]')).map(function (x) { return x.hasAttribute('data-none') ? null : x; });
    var skau = stage.querySelector('.eco__skau');
    var caps = [].slice.call(host.querySelectorAll('.sc'));
    var n = areas.length;
    var gTangle = el('g', { fill: 'none', stroke: 'currentColor', 'stroke-width': '.18' }, svg);
    var gSpoke = el('g', { fill: 'none', stroke: 'currentColor', 'stroke-width': '.25' }, svg);
    var ring = el('circle', { cx: 0, cy: 0, r: 15, fill: 'none', 'stroke-width': '.3' }, svg);
    var ring2 = el('circle', { cx: 0, cy: 0, r: 30, fill: 'none', 'stroke-width': '.22' }, svg);
    var gDots = el('g', {}, svg);
    var tangles = [], spokes = [], dots = [];
    for (var i = 0; i < n; i++) {
      tangles.push([el('path', {}, gTangle), i, (i + 3) % n]);
      tangles.push([el('path', {}, gTangle), i, (i + 2) % n]);
      spokes.push(el('path', {}, gSpoke));
      for (var k = 0; k < 3; k++) dots.push({ n: el('circle', { r: .55 }, gDots), i: i, o: (k / 3 + i * .11) % 1 });
    }
    var zs = areas.map(function (_, i) { return ((i * 37) % 7) / 7 - .45; });
    var narrow = stage.offsetWidth < 520;
    window.addEventListener('resize', function () { narrow = stage.offsetWidth < 520; });

    function proj(x, y, z, cam) {
      var f = 1 / (1 - z * .32 * (.5 + cam));
      return { x: x * f, y: y * f, f: f };
    }
    function put(node, P, extra) {
      node.style.left = (50 + P.x) + '%';
      node.style.top = (50 + P.y) + '%';
      node.style.transform = 'translate(-50%,-50%) scale(' + (P.f * (extra || 1)).toFixed(3) + ')';
    }
    function update(p, t) {
      var intro = w(p, .08, .30), tang = w(p, .20, .34) * (1 - w(p, .70, .84));
      var skauIn = w(p, .34, .46), flow = w(p, .54, .70), integ = w(p, .70, .86), fin = w(p, .88, 1);
      var cam = w(p, 0, .5) * .6 + integ * .2;
      var pull = 1 - fin * .1;
      stage.style.transform = 'rotateX(' + (8 - integ * 8) + 'deg) scale(' + pull.toFixed(3) + ')';
      var Ra = lerp(8, narrow ? 33 : 41, intro) - integ * (narrow ? 7 : 10), Rp = 26 - integ * 7;
      var posA = [], posP = [];
      for (var i = 0; i < n; i++) {
        var a = rad(-90 + i * 360 / n + (1 - intro) * 25);
        var z = zs[i] * (1 - integ * .8);
        var pa = proj(Math.cos(a) * Ra, Math.sin(a) * Ra * .92, z, cam);
        posA.push(pa);
        put(areas[i], pa);
        areas[i].style.opacity = (intro * (1 - fin * .0)).toFixed(3);
        areas[i].classList.toggle('is-solved', flow > .2 && !!prods[i]);
        var pr = prods[i];
        var arrive = w(p, .38 + i * .018, .54 + i * .018);
        var rr = lerp(66, Rp, arrive);
        var zp = lerp(1, .12, arrive);
        var pp = proj(Math.cos(a) * rr, Math.sin(a) * rr * .92, zp, cam);
        posP.push(pp);
        if (pr) { put(pr, pp, .9 + arrive * .1); pr.style.opacity = arrive.toFixed(3); }
      }
      core.style.transform = 'translate(-50%,-50%) scale(' + (1 + Math.sin(t * .0012) * .015 + fin * .08).toFixed(3) + ')';
      skau.style.opacity = skauIn.toFixed(3);
      skau.style.transform = 'translate(-50%,-50%) scale(' + (.9 + skauIn * .1).toFixed(3) + ')';
      ring.setAttribute('stroke', 'var(--pc-t, var(--mint))'); ring.setAttribute('opacity', skauIn.toFixed(3));
      ring.setAttribute('r', (15 + fin * 0).toFixed(2));
      var L = 2 * Math.PI * 30;
      ring2.setAttribute('stroke', 'var(--pc-t, var(--mint))'); ring2.setAttribute('stroke-dasharray', L.toFixed(1));
      ring2.setAttribute('stroke-dashoffset', (L * (1 - fin)).toFixed(1));
      ring2.setAttribute('opacity', (fin * .8).toFixed(3));
      ring2.setAttribute('r', (30 - integ * 4).toFixed(2));
      gTangle.style.opacity = tang * .55;
      tangles.forEach(function (T) {
        var A = posA[T[1]], B = posA[T[2]], j = T[1] % 2 ? 9 : -9;
        T[0].setAttribute('d', 'M' + A.x + ' ' + A.y + ' Q ' + j + ' ' + (-j) + ' ' + B.x + ' ' + B.y);
      });
      gSpoke.style.opacity = (flow * (1 - integ * .3)).toFixed(3);
      spokes.forEach(function (s, i) {
        var P = posP[i], A = posA[i];
        s.setAttribute('d', 'M' + A.x + ' ' + A.y + ' L' + P.x + ' ' + P.y + ' L0 0');
        s.style.display = prods[i] ? '' : 'none';
      });
      dots.forEach(function (d) {
        if (!prods[d.i]) { d.n.style.display = 'none'; return; }
        var u = (d.o + t * .00007 * (1 + integ)) % 1, A = posA[d.i], P = posP[d.i], x, y;
        if (u < .45) { var q = u / .45; x = lerp(A.x, P.x, q); y = lerp(A.y, P.y, q); }
        else { q = (u - .45) / .55; x = lerp(P.x, 0, q); y = lerp(P.y, 0, q); }
        d.n.style.display = ''; d.n.setAttribute('cx', x); d.n.setAttribute('cy', y);
        d.n.setAttribute('opacity', (flow * Math.sin(u * Math.PI)).toFixed(3));
      });
      // billedtekster
      var bounds = [0, .12, .32, .50, .70, .86, 1.01], act = 0;
      for (var s = 0; s < bounds.length - 1; s++) if (p >= bounds[s]) act = s;
      caps.forEach(function (c, i) { c.classList.toggle('on', i === Math.min(act, caps.length - 1)); });
      host.style.setProperty('--prog', p.toFixed(3));
    }
    return update;
  }

  /* ---------- Scene: produkthistorie (Acounteee) ---------- */
  function product(host) {
    var stage = host.querySelector('.ps__stage');
    var win = stage.querySelector('.ps__win');
    var ins = [].slice.call(stage.querySelectorAll('[data-in]'));
    var rows = [].slice.call(stage.querySelectorAll('.ps__row'));
    var kpis = [].slice.call(stage.querySelectorAll('.ps__kpi'));
    var chart = stage.querySelector('.ps__chart');
    var line = stage.querySelector('.ps__line'), fore = stage.querySelector('.ps__fore');
    var state = stage.querySelector('.ps__state');
    var svg = stage.querySelector('.ps__flows');
    var ledger = stage.querySelector('.ps__ledger'), dash = stage.querySelector('.ps__dash');
    var caps = [].slice.call(host.querySelectorAll('.sc'));
    var paths = ins.map(function () { return el('path', { fill: 'none', 'stroke-width': '.25' }, svg); });
    var n = ins.length;
    var labels = (state && state.dataset.states || 'Rå data|Struktureret|Bogført').split('|');
    var lineLen = line ? line.getTotalLength() : 0;
    var foreLen = fore ? fore.getTotalLength() : 0;
    if (line) line.style.strokeDasharray = lineLen;
    if (fore) fore.style.strokeDasharray = '3 3';

    function update(p, t) {
      var inA = w(p, .04, .24), proc = w(p, .26, .48), struct = w(p, .34, .56), book = w(p, .46, .60);
      var intel = w(p, .60, .78), out = w(p, .84, 1);
      var zoom = 1 + w(p, .24, .38) * 0.7 - w(p, .56, .70) * .35 - out * .35;
      stage.style.transform = 'scale(' + zoom.toFixed(3) + ') rotateX(' + ((1 - inA) * 6) + 'deg)';
      win.style.setProperty('--open', proc.toFixed(3));
      win.classList.toggle('is-open', proc > .05);
      for (var i = 0; i < n; i++) {
        var ang = rad(-90 + i * 360 / n + 18), R = lerp(54, 40, inA) * 1;
        var settle = proc;              // input glider ind i systemet
        var r = lerp(R, 9, settle) * (1 - out * 0) ;
        var x = Math.cos(ang) * lerp(R * 1.25, r * 1.25, 1) , y = Math.sin(ang) * r * .8;
        var z = (i % 2 ? .5 : -.3) * (1 - settle);
        var f = 1 / (1 - z * .3);
        var o = inA * (1 - w(p, .30, .48));
        ins[i].style.left = (50 + x * f) + '%'; ins[i].style.top = (50 + y * f) + '%';
        ins[i].style.transform = 'translate(-50%,-50%) scale(' + (f * (1 - settle * .4)).toFixed(3) + ')';
        ins[i].style.opacity = (o * (1 - out * 0)).toFixed(3);
        // linjer fra input til centrum
        var vis = inA * (1 - proc);
        paths[i].setAttribute('d', 'M' + (x * f) + ' ' + (y * f) + ' Q' + (x * .3) + ' ' + (y * .3 + (i % 2 ? 6 : -6)) + ' 0 0');
        paths[i].setAttribute('stroke', 'var(--pc-t, var(--mint))');
        paths[i].setAttribute('opacity', (vis * .6).toFixed(3));
      }
      // rækker: rå -> struktureret -> bogført
      rows.forEach(function (r, i) {
        var j = (i % 2 ? 1 : -1) * (1 - struct) * (10 + (i * 7) % 18);
        var rot = (1 - struct) * ((i * 29) % 9 - 4);
        r.style.transform = 'translateX(' + j + 'px) rotate(' + rot + 'deg)';
        r.style.opacity = proc.toFixed(3);
        r.classList.toggle('is-booked', book > (i + 1) / (rows.length + 1));
      });
      if (state) state.textContent = (intel > .5 && labels[3]) ? labels[3] : book > .5 ? labels[Math.min(2, labels.length - 1)] : struct > .35 ? labels[Math.min(1, labels.length - 1)] : labels[0];
      ledger.style.opacity = (1 - w(p, .58, .68)).toFixed(3);
      ledger.style.transform = 'translateY(' + (-w(p, .58, .68) * 14) + 'px) scale(' + (1 - w(p, .58, .68) * .05) + ')';
      dash.style.opacity = intel.toFixed(3);
      kpis.forEach(function (k, i) {
        var a = w(p, .62 + i * .04, .74 + i * .04);
        k.style.opacity = a.toFixed(3); k.style.transform = 'translateY(' + ((1 - a) * 16) + 'px)';
      });
      if (line) line.style.strokeDashoffset = lineLen * (1 - w(p, .66, .80));
      if (fore) fore.style.opacity = w(p, .76, .86).toFixed(3);
      if (chart) chart.style.opacity = w(p, .64, .72).toFixed(3);
      host.classList.toggle('is-out', out > .3);
      var act = Math.min(caps.length - 1, Math.floor(clamp(p, 0, .9999) * caps.length));
      caps.forEach(function (c, i) { c.classList.toggle('on', i === act); });
    }
    return update;
  }

  /* ---------- Scene: arkitektur (exploded view) ---------- */
  function architecture(host) {
    var stack = host.querySelector('.ar__stack');
    var layers = [].slice.call(stack.querySelectorAll('.ar__layer'));
    var caps = [].slice.call(host.querySelectorAll('.sc'));
    var spine = stack.querySelector('.ar__spine');
    var dots = [].slice.call(stack.querySelectorAll('.ar__dot'));
    var N = layers.length, pad = .1, endAt = .88;
    function update(p, t) {
      var ex = w(p, .04, .16) * (1 - w(p, endAt, 1));
      var gap = lerp(7, 66, ex);
      var run = clamp((p - .16) / (endAt - .16), 0, .9999);
      var pos = run * N, act = p < .16 || p >= endAt ? -1 : Math.floor(pos);
      var fz = pos - Math.floor(pos);
      var zc = act < 0 ? (N - 1) * gap / 2 : (N - 1 - clamp(pos - .5, 0, N - 1)) * gap;
      var rx = lerp(62, 54, ex) + (act >= 0 ? Math.sin(pos * .9) * 3 : 0);
      var rz = lerp(-34, -28, ex) + (act >= 0 ? Math.cos(pos * .9) * 4 : 0);
      var s = 1 - w(p, endAt, 1) * .12;
      stack.style.transform = 'scale(' + s.toFixed(3) + ') rotateX(' + rx.toFixed(2) + 'deg) rotateZ(' + rz.toFixed(2) + 'deg) translateZ(' + (-zc + (N - 1) * gap / 2 * 0.0).toFixed(1) + 'px)';
      layers.forEach(function (L, i) {
        var z = (N - 1 - i) * gap;
        var isA = i === act;
        var near = act < 0 ? 1 : isA ? 1 : .22;
        var lift = isA ? 42 * Math.sin(Math.min(1, fz * 6, (1 - fz) * 6 + .0) * Math.PI / 2) : 0;
        L.style.transform = 'translateZ(' + (z + lift).toFixed(1) + 'px)';
        L.style.opacity = near.toFixed(3);
        L.classList.toggle('is-active', isA);
      });
      if (spine) spine.style.opacity = (ex * .9).toFixed(3);
      dots.forEach(function (d, i) {
        var u = (t * .00014 + i / dots.length) % 1;
        d.style.transform = 'translateZ(' + (u * (N - 1) * gap).toFixed(1) + 'px) translate(-50%,-50%)';
        d.style.opacity = (ex * Math.sin(u * Math.PI)).toFixed(3);
      });
      caps.forEach(function (c, i) { c.classList.toggle('on', i === act || (act < 0 && ((p < .16 && i === N) || (p >= endAt && i === N + 1)))); });
    }
    return update;
  }

  var factories = { eco: ecosystem, product: product, arch: architecture };

  [].forEach.call(scenes, function (host) {
    var f = factories[host.getAttribute('data-cine')];
    if (!f) return;
    var pin = host.querySelector('.cine__pin');
    var update = f(host), target = 0, cur = 0, running = false, visible = false;
    function measure() {
      var r = host.getBoundingClientRect();
      var top = parseFloat(getComputedStyle(pin).top) || 0;
      target = clamp((top - r.top) / Math.max(1, r.height - pin.offsetHeight), 0, 1);
    }
    function frame(t) {
      measure();
      cur += (target - cur) * .14;
      if (Math.abs(target - cur) < .0004) cur = target;
      update(cur, t);
      if (visible) requestAnimationFrame(frame); else running = false;
    }
    new IntersectionObserver(function (es) {
      visible = es[0].isIntersecting;
      if (visible && !running) { running = true; requestAnimationFrame(frame); }
    }, { rootMargin: '10% 0px' }).observe(host);
    host.__cine = { set: function (p) { cur = target = p; update(p, performance.now()); } };
  });
})();
